import { MenuProps, Menu, styled, Theme } from '@mui/material';

const CustomMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }: { theme: Theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 100,
    maxWidth: 600,
    padding: '20px 25px',
    boxShadow: '10px 10px 50px 0px rgba(0, 71, 66, 0.3)',
  },
}));

export default CustomMenu;
